import { useSyncExternalStore } from "react";

import { SHEET_DESKTOP_MIN_WIDTH_PX } from "./tokens";

const QUERY = `(min-width: ${SHEET_DESKTOP_MIN_WIDTH_PX}px)`;

function subscribe(callback: () => void): () => void {
  if (typeof window === "undefined") return () => {};
  const mql = window.matchMedia(QUERY);
  mql.addEventListener("change", callback);
  return () => mql.removeEventListener("change", callback);
}

function getSnapshot(): boolean {
  if (typeof window === "undefined") return false;
  return window.matchMedia(QUERY).matches;
}

function getServerSnapshot(): boolean {
  // SSR default: assume mobile (smaller surface) so the first paint never
  // overflows on phones; desktop hydration upgrades to the dialog variant.
  return false;
}

/**
 * `true` when viewport width meets the desktop breakpoint. Drives the
 * bottom-sheet ↔ dialog switch in ResponsiveSheet shells. Subscribes to
 * `matchMedia` so resize / orientation change also flips the layout.
 */
export function useIsDesktop(): boolean {
  return useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
}
